module.exports = __webpack_public_path__ + "static/media/storeCard.ef96e184.svg";